import styled from "styled-components";
import { CardContainer } from "../styled";

export const Content = styled.div.attrs({})``;

// Adicionar um styled container para manter consistência
export const StyledCardContainer = styled(CardContainer)`
  height: 100%;
  min-height: 100%;
  max-height: 400px;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto; /* Permite rolagem horizontal */
`;
